import { TimePicker } from '../../../../../../../../features/date-time/time-picker/time-picker';
import { useLang } from '../../../../../../../../hooks/use-lang';
import { useShiftsStore } from '../../../../../../../../store/use-shifts-store';
import s from './shifts-controls-schedule-modal-step-2.module.css';

export const ShiftsControlsScheduleModalStep2 = () => {
  const { t } = useLang();
  const { shift, handleUpdateShift } = useShiftsStore();

  return (
    <div className={s.feature}>
      <h3>{t('Выбрать время')}</h3>
      <div className={s.range}>
        <TimePicker
          className={s.timePicker}
          placeholder={t('Начало')}
          name="startTime"
          value={shift?.startTime}
          onChange={(e) => handleUpdateShift({ ...shift, startTime: e })}
        />
        <TimePicker
          className={s.timePicker}
          placeholder={t('Завершение')}
          value={shift?.endTime}
          name="endTime"
          onChange={(e) => handleUpdateShift({ ...shift, endTime: e })}
        />
      </div>
    </div>
  );
};
